import { Component, Input } from '@angular/core';
import { ExportExcelService } from '../../../common/services/export-excel.service';
import { AuditInfo } from '../../../domain-model/audit-info.class';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { AuditService } from '../../../services/audit.service';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { OurUserService } from '../../../users/services/user.service';


@Component({
  selector: 'app-audit-history',
  templateUrl: './audit-history.component.html',
  styleUrls: ['./audit-history.component.scss']
})
export class AuditHistoryComponent {
  @Input() companyId: string;

  loggedInUser: IUserInfo;
  auditHistory: AuditInfo[] = [];
  loadingAuditHistory: boolean = true;
  columns: any[];
  tableColumns: any[];
  exportColumns: any[];

  constructor(private helpService: HelpModalService,
    private exportExcelService: ExportExcelService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private auditService: AuditService,
    private errorHandlingService: ErrorHandlingService,
    private userService: OurUserService
  ) {
  }

  ngOnInit(): void {
    const auditBreadcrumbs = new Array<IBreadcrumb>();
    auditBreadcrumbs.push({ label: 'Audit History', iconName: 'history' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(auditBreadcrumbs);

    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser?.companyId;
      this.initialiseColumnDataTableColumns();
      this.loadAuditHistory();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }
  

  initialiseColumnDataTableColumns() {
    this.columns = null;
    this.columns = [
      { field: 'auditDate', header: 'Date', type: 'date' },
      { field: 'auditAction', header: 'Action', type: 'text' },
      { field: 'updatedBy', header: 'User', type: 'text' },
      { field: 'operation', header: 'Operation', type: 'text' }
      //{ field: 'auditString', header: 'Audit String', type: 'text' }
    ];
  }

  loadAuditHistory() {
    this.auditService.getAuditHistory(this.companyId).subscribe(allAuditData => {
      this.auditHistory = [];
      allAuditData?.forEach(auditData => this.auditHistory.push(new AuditInfo(auditData)));
      this.loadingAuditHistory = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  openAuditHistoryHelp() {
    this.helpService.openHelpModal(HelpConsts.AuditHistoryHelp);
  }

  exportToExcel() {
    //TODO: Not implemented
  }
}
